module.exports = __webpack_public_path__ + "static/popup-767127be9cd348c3552e3bd94476447a.png";